<template>
  <div v-if="place.id_place"
       class="menu menu-column menu-title-gray-700 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500 fw-bold" data-kt-menu="true">
    <div class="menu-item">
      <router-link to="/dashboard" class="menu-link" title="Visualizar informações">
        <span class="menu-icon">
          <i class="bi bi-grid fs-3"></i>
        </span>
        <span class="menu-title">Painel</span>
      </router-link>
    </div>

    <div class="menu-item" v-if="showAgendaMenu">
      <router-link to="/schedules" class="menu-link" title="Agenda">
        <span class="menu-icon">
          <i class="bi bi-calendar2-week fs-3"></i>
        </span>
        <span class="menu-title">Agenda</span>
      </router-link>
    </div>

    <div class="menu-item" v-if="showAtenderMenu">
      <router-link to="/attendances" class="menu-link" title="Atendimentos">
            <span class="menu-icon">
              <i class="bi bi-clipboard2-pulse fs-3"></i>
            </span>
        <span class="menu-title">Atender</span>
      </router-link>
    </div>

    <div class="menu-item" v-if="showVendasMenu">
      <router-link to="/budgets" class="menu-link" title="Vendas">
        <span class="menu-icon">
          <i class="bi bi-cash-coin fs-3"></i>
        </span>
        <span class="menu-title">Vendas</span>
      </router-link>
    </div>

    <div data-kt-menu-trigger="click" v-if="showFinanceiroMenu"
         data-kt-menu-placement="right-start" class="menu-item">
      <span class="menu-link menu-center" title="Financeiro">
        <span class="menu-icon me-0">
          <i class="bi bi-cash-stack"></i>
        </span>
        <span class="menu-title">Financeiro</span>
      </span>
      <div class="menu-sub menu-sub-dropdown w-225px w-lg-275px px-1 py-4">
        <div class="menu-item" v-if="showFinanceiroOperacoesSection">
          <div class="menu-content">
            <span class="menu-section fs-5 fw-bolder ps-1 py-1">Módulo Financeiro</span>
          </div>
        </div>
        <div class="menu-item" v-if="showFinanceiroBillsToPay">
          <router-link class="menu-link" to="/finance/bills-to-pay"
                       title="Contas a pagar">
              <span class="menu-icon">
                <i class="bi bi-clipboard2-pulse"></i>
              </span>
            <span class="menu-title">Contas a pagar</span>
          </router-link>
        </div>
        <div class="menu-item" v-if="showFinanceiroBillsToReceive">
          <router-link class="menu-link" to="/finance/bills-to-receive" title="Contas a receber">
              <span class="menu-icon">
                <i class="bi bi-person-vcard"></i>
              </span>
            <span class="menu-title">Contas a receber</span>
          </router-link>
        </div>
        <div class="menu-item" v-if="showFinanceiroCashFlow">
          <router-link class="menu-link" to="/finance/cash-flow" title="Fluxo de caixa">
              <span class="menu-icon">
                <i class="bi bi-graph-up-arrow"></i>
              </span>
            <span class="menu-title">Fluxo de caixa</span>
          </router-link>
        </div>
        <div class="menu-item" v-if="showFinanceiroCadastrosSection">
          <div class="menu-content">
            <span class="menu-section fs-6 fw-bold ps-1 py-1 mt-3">Cadastros Financeiros</span>
          </div>
        </div>
        <div class="menu-item" v-if="showFinanceiroCostCenters">
          <router-link class="menu-link" to="/finance/cost-centers" title="Centro de Custos">
              <span class="menu-icon">
                <i class="bi bi-building"></i>
              </span>
            <span class="menu-title">Centro de Custos</span>
          </router-link>
        </div>
        <div class="menu-item" v-if="showFinanceiroTransactionCategories">
          <router-link class="menu-link" to="/finance/transaction-categories" title="Categorias de Transação">
              <span class="menu-icon">
                <i class="bi bi-tags"></i>
              </span>
            <span class="menu-title">Categorias</span>
          </router-link>
        </div>
        <div class="menu-item" v-if="showFinanceiroBankAccounts">
          <router-link class="menu-link" to="/finance/bank-accounts" title="Contas Bancárias">
              <span class="menu-icon">
                <i class="bi bi-bank"></i>
              </span>
            <span class="menu-title">Contas Bancárias</span>
          </router-link>
        </div>
        <div class="menu-item" v-if="showFinanceiroCustomers">
          <router-link class="menu-link" to="/finance/customers"
                       title="Clientes">
              <span class="menu-icon">
                <i class="bi bi-person-check"></i>
              </span>
            <span class="menu-title">Clientes</span>
          </router-link>
        </div>
        <div class="menu-item" v-if="showFinanceiroSuppliers">
          <router-link class="menu-link" to="/finance/suppliers"
                       title="Fornecedores">
              <span class="menu-icon">
                <i class="bi bi-truck"></i>
              </span>
            <span class="menu-title">Fornecedores</span>
          </router-link>
        </div>
        <div class="menu-item" v-if="showFinanceiroNfseSection">
          <div class="menu-content">
            <span class="menu-section fs-6 fw-bold ps-1 py-1 mt-3">NFSe</span>
          </div>
        </div>
        <div class="menu-item" v-if="showFinanceiroNfse">
          <router-link class="menu-link" to="/nfse" title="Notas Fiscais de Serviço">
            <span class="menu-icon">
              <i class="bi bi-receipt"></i>
            </span>
            <span class="menu-title">Notas Fiscais</span>
          </router-link>
        </div>
      </div>
    </div>

    <div data-kt-menu-trigger="click"
         v-if="showTissMenu"
         data-kt-menu-placement="right-start"
         class="menu-item">
      <span class="menu-link menu-center" title="Guias">
        <span class="menu-icon me-0">
          <i class="bi bi-file-earmark-medical fs-3"></i>
        </span>
        <span class="menu-title">Guias</span>
      </span>
      <div class="menu-sub menu-sub-dropdown w-225px w-lg-275px px-1 py-4">
        <div class="menu-item" v-if="showTissGuiasSection">
          <div class="menu-content">
            <span class="menu-section fs-5 fw-bolder ps-1 py-1">Guias</span>
          </div>
        </div>
        <div class="menu-item" v-if="showTissGuias">
          <router-link class="menu-link" to="/tiss/guides" title="Guias">
              <span class="menu-icon">
                <i class="bi bi-file-earmark-medical"></i>
              </span>
            <span class="menu-title">Gerenciar Guias</span>
          </router-link>
        </div>
        <div class="menu-item" v-if="showTissCadastrosSection">
          <div class="menu-content">
            <span class="menu-section fs-6 fw-bold ps-1 py-1 mt-3">Cadastros</span>
          </div>
        </div>
        <div class="menu-item" v-if="showTissPrestador">
          <router-link class="menu-link" to="/finance/suppliers"
                       title="Prestador (cadastro de fornecedores)">
              <span class="menu-icon">
                <i class="bi bi-truck"></i>
              </span>
            <span class="menu-title">Prestador</span>
          </router-link>
        </div>
      </div>
    </div>

    <div class="menu-item" v-if="showPacientesMenu">
      <router-link to="/patients" class="menu-link" title="Meus pacientes">
        <span class="menu-icon">
          <i class="bi bi-people fs-3"></i>
        </span>
        <span class="menu-title">Pacientes</span>
      </router-link>
    </div>

    <div class="menu-item" v-if="showPesquisasMenu">
      <router-link to="/surveys" class="menu-link" title="Pesquisas">
        <span class="menu-icon">
          <i class="bi bi-file-earmark-bar-graph"></i>
        </span>
        <span class="menu-title">Pesquisas</span>
      </router-link>
    </div>

    <div data-kt-menu-trigger="click" v-if="showPlanosSaudeMenu"
         data-kt-menu-placement="right-start" class="menu-item">
      <span class="menu-link menu-center" title="Planos de saúde">
        <span class="menu-icon me-0">
          <i class="bi bi-person-vcard-fill"></i>
        </span>
        <span class="menu-title">Planos</span>
      </span>
      <div class="menu-sub menu-sub-dropdown w-225px w-lg-275px px-1 py-4">
        <div class="menu-item" v-if="showPlanosSaudeGerenciarSection">
          <div class="menu-content">
            <span class="menu-section fs-5 fw-bolder ps-1 py-1">Gerenciar planos</span>
          </div>
        </div>
        <div class="menu-item" v-if="showPlanosSaudePlanos">
          <router-link class="menu-link" to="/plans"
                       title="Meus Planos">
              <span class="menu-icon">
                <i class="bi bi-clipboard2-pulse"></i>
              </span>
            <span class="menu-title">Planos</span>
          </router-link>
        </div>
        <div class="menu-item" v-if="showPlanosSaudeAssinantes">
          <router-link class="menu-link" to="/subscribers" title="Assinantes">
              <span class="menu-icon">
                <i class="bi bi-person-vcard"></i>
              </span>
            <span class="menu-title">Assinantes</span>
          </router-link>
        </div>
        <div class="menu-item" v-if="showPlanosSaudeEmpresas">
          <router-link class="menu-link" to="/plans/companies" title="Empresas Conveniadas">
              <span class="menu-icon">
                <i class="bi bi-building"></i>
              </span>
            <span class="menu-title">Empresas Conveniadas</span>
          </router-link>
        </div>
        <div class="menu-item" v-if="showPlanosSaudeAnalisesSection">
          <div class="menu-content">
            <span class="menu-section fs-5 fw-bolder ps-1 py-1">Análises e Relatórios</span>
          </div>
        </div>
        <div class="menu-item" v-if="showPlanosSaudeDashboard">
          <router-link class="menu-link" to="/plans/dashboard" title="Dashboard">
              <span class="menu-icon">
                <i class="bi bi-graph-up"></i>
              </span>
            <span class="menu-title">Dashboard</span>
          </router-link>
        </div>
        <div class="menu-item" v-if="showPlanosSaudeRelatorios">
          <router-link class="menu-link" to="/plans/reports" title="Relatórios">
              <span class="menu-icon">
                <i class="bi bi-file-earmark-text"></i>
              </span>
            <span class="menu-title">Relatórios</span>
          </router-link>
        </div>
        <div class="menu-item" v-if="showPlanosSaudeContratosSection">
          <div class="menu-content">
            <span class="menu-section fs-5 fw-bolder ps-1 py-1">Contratos</span>
          </div>
        </div>
        <div class="menu-item" v-if="showPlanosSaudeContratos">
          <router-link class="menu-link" to="/plans/contracts" title="Gestão de Contratos">
            <span class="menu-icon">
              <i class="bi bi-file-earmark-check"></i>
            </span>
            <span class="menu-title">Contratos</span>
          </router-link>
        </div>
        <div class="menu-item" v-if="showPlanosSaudeModelos">
          <router-link class="menu-link" to="/plans/contract-templates" title="Modelos de Contrato">
            <span class="menu-icon">
              <i class="bi bi-file-earmark-richtext"></i>
            </span>
            <span class="menu-title">Modelos</span>
          </router-link>
        </div>
      </div>
    </div>

    <div data-kt-menu-trigger="click" v-if="showProntuarioMenu" data-kt-menu-placement="right-start" class="menu-item">
      <span class="menu-link menu-center" title="Prontuário">
        <span class="menu-icon me-0">
          <i class="bi bi-clipboard-data fs-2"></i>
        </span>
        <span class="menu-title">Prontuário</span>
      </span>
      <div class="menu-sub menu-sub-dropdown w-225px w-lg-275px px-1 py-4">
        <div class="menu-item" v-if="showProntuarioModelosSection">
          <div class="menu-content">
            <span class="menu-section fs-5 fw-bolder ps-1 py-1">Modelos</span>
          </div>
        </div>
        <div class="menu-item" v-if="showProntuarioRecordTypes">
          <router-link class="menu-link" to="/record-types"
                       title="Modelos de Prontuários">
              <span class="menu-icon">
                <i class="bi bi-clipboard2-pulse"></i>
              </span>
            <span class="menu-title">Modelos de Prontuários</span>
          </router-link>
        </div>
        <div class="menu-item" v-if="showProntuarioPrescriptionProtocols">
          <router-link class="menu-link" to="/prescription-protocols"
                       title="Modelos de Prescrições">
              <span class="menu-icon">
                <i class="bi bi-file-medical"></i>
              </span>
            <span class="menu-title">Modelos de Prescrições</span>
          </router-link>
        </div>
        <div class="menu-item" v-if="showProntuarioExamProtocols">
          <router-link class="menu-link" to="/exam-protocols"
                       title="Modelos de Exames">
              <span class="menu-icon">
                <i class="bi bi-journal-medical"></i>
              </span>
            <span class="menu-title">Modelos de Exames</span>
          </router-link>
        </div>
        <div class="menu-item" v-if="showProntuarioDocumentTemplates">
          <router-link class="menu-link" to="/document-templates"
                       title="Modelos de Documentos">
              <span class="menu-icon">
                <i class="bi bi-file-earmark-richtext"></i>
              </span>
            <span class="menu-title">Modelos de Documentos</span>
          </router-link>
        </div>
        <div class="menu-item" v-if="showProntuarioFormulariosSection">
          <div class="menu-content">
            <span class="menu-section fs-6 fw-bold ps-1 py-1 mt-3">Formulários</span>
          </div>
        </div>
        <div class="menu-item" v-if="showProntuarioPreSchedule">
          <router-link class="menu-link" to="/pre-schedule-forms"
                       title="Formulários de Pré-Agendamento">
              <span class="menu-icon">
                <i class="bi bi-file-earmark-text"></i>
              </span>
            <span class="menu-title">Pré-Agendamento</span>
          </router-link>
        </div>
        <div class="menu-item" v-if="showProntuarioSettings">
          <router-link class="menu-link" to="/medical-record-settings"
                       title="Configurações">
              <span class="menu-icon">
                <i class="bi bi-gear"></i>
              </span>
            <span class="menu-title">Configurações</span>
          </router-link>
        </div>
      </div>
    </div>

    <div data-kt-menu-trigger="click" v-if="showCadastrosMenu" data-kt-menu-placement="right-start" class="menu-item">
      <span class="menu-link menu-center" title="Meus Cadastros">
        <span class="menu-icon me-0">
          <i class="bi bi-archive fs-2"></i>
        </span>
        <span class="menu-title">Cadastros</span>
      </span>
      <div class="menu-sub menu-sub-dropdown w-225px w-lg-275px px-1 py-4">
        <div class="menu-item" v-if="showCadastrosSection">
          <div class="menu-content">
            <span class="menu-section fs-5 fw-bolder ps-1 py-1">Meus Cadastros</span>
          </div>
        </div>
        <div class="menu-item" v-if="showCadastrosUsers">
          <router-link class="menu-link" to="/users"
             title="Usuários">
              <span class="menu-icon">
                <i class="bi bi-box2-heart"></i>
              </span>
            <span class="menu-title">Usuários</span>
          </router-link>
        </div>
        <div class="menu-item" v-if="showCadastrosProfessionals">
          <router-link class="menu-link" to="/professionals"
             title="Dados cadastrais do profissional">
              <span class="menu-icon">
                <i class="bi bi-people"></i>
              </span>
            <span class="menu-title">Profissionais</span>
          </router-link>
        </div>
        <div class="menu-item" v-if="showCadastrosPlace">
          <router-link class="menu-link" to="/place"
             title="Dados cadastrais do local de atendimento">
              <span class="menu-icon">
                <i class="bi bi-shop-window"></i>
              </span>
            <span class="menu-title">Local de atendimento</span>
          </router-link>
        </div>
        <div class="menu-item" v-if="showCadastrosPaymentMethods">
          <router-link class="menu-link" to="/payment-methods"
             title="Formas de recebimento">
              <span class="menu-icon">
                <i class="bi bi-cash-coin"></i>
              </span>
            <span class="menu-title">Formas de recebimento</span>
          </router-link>
        </div>
        <div class="menu-item" v-if="showCadastrosVisitValues">
          <router-link class="menu-link" to="/visit-values"
                       title="Tabela de Valores">
              <span class="menu-icon">
                <i class="bi bi-cash-coin"></i>
              </span>
            <span class="menu-title">Tabela de Valores</span>
          </router-link>
        </div>
        <div class="menu-item" v-if="showCadastrosExams">
          <router-link class="menu-link" to="/exams"
                       title="Exames/Procedimentos">
              <span class="menu-icon">
                <i class="bi bi-activity"></i>
              </span>
            <span class="menu-title">Exames/Procedimentos</span>
          </router-link>
        </div>
        <div class="menu-item" v-if="showCadastrosSupplierTransferValues">
          <router-link class="menu-link" to="/supplier-transfer-values"
                       title="Valores de repasse para prestadores">
              <span class="menu-icon">
                <i class="bi bi-cash-stack"></i>
              </span>
            <span class="menu-title">Tabela de Valores (Convênios)</span>
          </router-link>
        </div>
        <div class="menu-item" v-if="showCadastrosTransferTables">
          <router-link class="menu-link" to="/transfer-tables"
                       title="Tabelas de repasse">
              <span class="menu-icon">
                <i class="bi bi-table"></i>
              </span>
            <span class="menu-title">Tabelas de repasse</span>
          </router-link>
        </div>
        <div class="menu-item" v-if="showCadastrosSpecialties">
          <router-link class="menu-link" to="/specialties"
                       title="Especialidades">
              <span class="menu-icon">
                <i class="bi bi-mortarboard"></i>
              </span>
            <span class="menu-title">Especialidades</span>
          </router-link>
        </div>
        <div class="menu-item" v-if="showCadastrosAccessTypes">
          <router-link class="menu-link" to="/access-types"
                       title="Permissões">
              <span class="menu-icon">
                <i class="bi bi-cash-coin"></i>
              </span>
            <span class="menu-title">Permissões</span>
          </router-link>
        </div>
        <div class="menu-item" v-if="showCadastrosInsurances">
          <router-link class="menu-link" to="/insurances"
             title="Convênios">
              <span class="menu-icon">
                <i class="bi bi-building"></i>
              </span>
            <span class="menu-title">Convênios Atendidos</span>
          </router-link>
        </div>
        <div class="menu-item" v-if="showCadastrosHolidays">
          <router-link class="menu-link" to="/holidays"
                       title="Feriados">
              <span class="menu-icon">
                <i class="bi bi-calendar-x"></i>
              </span>
            <span class="menu-title">Feriados</span>
          </router-link>
        </div>
        <div class="menu-item" v-if="showCadastrosServiceQueues">
          <router-link class="menu-link" to="/service-queues"
                       title="Filas de Atendimento">
              <span class="menu-icon">
                <i class="bi bi-line"></i>
              </span>
            <span class="menu-title">Filas de Atendimento</span>
          </router-link>
        </div>
        <div class="menu-item" v-if="showCadastrosTerminals">
          <router-link class="menu-link" to="/terminals"
                       title="Totens, Telas e guichês">
              <span class="menu-icon">
                <i class="bi bi-tv"></i>
              </span>
            <span class="menu-title">Totens e guichês</span>
          </router-link>
        </div>
      </div>
    </div>
   </div>
</template>

<script>

import Permission from "../../../helpers/permission";
import debounce from "../../../helpers/debounce";
import { hasPlatformFeature as checkPlatformFeature, hasPlanFeature as checkPlanFeature } from "../../../helpers/platformFeature";

export default {
    name: "Menu",
    created() {
        this.debouncedInitKtMenu = debounce(() => {
            this.$nextTick(() => {
                document.querySelectorAll('body > .menu-sub-dropdown').forEach((element) => {
                    element.remove();
                });

                if (typeof KTMenu !== 'undefined') {
                    KTMenu.createInstances();
                }
            });
        }, 100);
    },
    computed: {
      userAuth() {
          return this.$store.state.auth.user || {};
      },
      place() {
        return this.$store.state.auth.place || {};
      },
      showAgendaMenu() {
        return this.hasPermission('List Schedule') && this.hasPlatformFeature('agenda');
      },
      showAtenderMenu() {
        return (this.userAuth.id_prof || this.userAuth?.is_admin) && this.hasPlatformFeature('prontuario');
      },
      showVendasMenu() {
        return this.hasPermission('list.budget') && this.hasPlatformFeature('orcamentos');
      },
      showFinanceiroBillsToPay() {
        return this.hasPermission('List Bill To Pay');
      },
      showFinanceiroBillsToReceive() {
        return this.hasPermission('List Bill To Receive');
      },
      showFinanceiroCashFlow() {
        return this.hasPermission('List Cash Flow');
      },
      showFinanceiroCostCenters() {
        return this.hasPermission('List Cost Center');
      },
      showFinanceiroTransactionCategories() {
        return this.hasPermission('List Transaction Category');
      },
      showFinanceiroBankAccounts() {
        return this.hasPermission('List Bank Account');
      },
      showFinanceiroCustomers() {
        return this.hasPermission('List Customer');
      },
      showFinanceiroSuppliers() {
        return this.hasPermission('List Supplier');
      },
      showFinanceiroNfse() {
        return this.hasPermission('List NFSe') && this.hasPlatformFeature('nfse');
      },
      showFinanceiroOperacoesSection() {
        return this.showFinanceiroBillsToPay
          || this.showFinanceiroBillsToReceive
          || this.showFinanceiroCashFlow;
      },
      showFinanceiroCadastrosSection() {
        return this.showFinanceiroCostCenters
          || this.showFinanceiroTransactionCategories
          || this.showFinanceiroBankAccounts
          || this.showFinanceiroCustomers
          || this.showFinanceiroSuppliers;
      },
      showFinanceiroNfseSection() {
        return this.showFinanceiroNfse;
      },
      showFinanceiroMenu() {
        if (!this.hasPlatformFeature('financeiro')) {
          return false;
        }

        return this.showFinanceiroOperacoesSection
          || this.showFinanceiroCadastrosSection
          || this.showFinanceiroNfseSection;
      },
      showTissGuias() {
        return this.hasPermission('List TISS Batch');
      },
      showTissPrestador() {
        return this.hasPermission('List Supplier');
      },
      showTissGuiasSection() {
        return this.showTissGuias;
      },
      showTissCadastrosSection() {
        return this.showTissPrestador;
      },
      showTissMenu() {
        return this.hasPlatformFeature('tiss')
          && (this.showTissGuias || this.showTissPrestador);
      },
      showPacientesMenu() {
        return this.hasPermission('List Patient') && this.hasPlatformFeature('pacientes');
      },
      showPesquisasMenu() {
        return this.hasPermission('list.survey') && this.hasPlatformFeature('pesquisas');
      },
      showPlanosSaudePlanos() {
        return this.hasPermission('List Plan');
      },
      showPlanosSaudeAssinantes() {
        return this.hasPermission('Create Subscriber');
      },
      showPlanosSaudeEmpresas() {
        return this.hasPermission('List Plan');
      },
      showPlanosSaudeDashboard() {
        return this.hasPermission('View Plan Dashboard');
      },
      showPlanosSaudeRelatorios() {
        return this.hasPermission('View Plan Reports');
      },
      showPlanosSaudeContratos() {
        return this.hasPermission('List Contract');
      },
      showPlanosSaudeModelos() {
        return this.hasPermission('Create Contract Template');
      },
      showPlanosSaudeGerenciarSection() {
        return this.showPlanosSaudePlanos
          || this.showPlanosSaudeAssinantes
          || this.showPlanosSaudeEmpresas;
      },
      showPlanosSaudeAnalisesSection() {
        return this.showPlanosSaudeDashboard || this.showPlanosSaudeRelatorios;
      },
      showPlanosSaudeContratosSection() {
        return this.showPlanosSaudeContratos || this.showPlanosSaudeModelos;
      },
      showPlanosSaudeMenu() {
        if (!this.hasPlatformFeature('planos_saude')) {
          return false;
        }

        return this.showPlanosSaudeGerenciarSection
          || this.showPlanosSaudeAnalisesSection
          || this.showPlanosSaudeContratosSection;
      },
      showProntuarioRecordTypes() {
        if (!this.hasPlanFeature('prontuario.record_templates')) {
          return false;
        }

        return this.hasPermission('List Record Professional');
      },
      showProntuarioPrescriptionProtocols() {
        return this.hasPermission('List Prescription Protocol');
      },
      showProntuarioExamProtocols() {
        if (!this.hasPlanFeature('prontuario.exam_templates')) {
          return false;
        }

        return this.hasPermission('List Exam Protocol');
      },
      showProntuarioDocumentTemplates() {
        return this.hasPermission('List Document Template');
      },
      showProntuarioPreSchedule() {
        return this.hasPlatformFeature('agenda');
      },
      showProntuarioModelosSection() {
        return this.showProntuarioRecordTypes
          || this.showProntuarioPrescriptionProtocols
          || this.showProntuarioExamProtocols
          || this.showProntuarioDocumentTemplates;
      },
      showProntuarioFormulariosSection() {
        return this.showProntuarioPreSchedule;
      },
      showProntuarioSettings() {
        if (!this.hasPlanFeature('prontuario.record_sharing')) {
          return false;
        }

        return this.hasPermission('Share Medical Record');
      },
      showProntuarioMenu() {
        if (!this.hasPlatformFeature('prontuario')) {
          return false;
        }

        return this.showProntuarioModelosSection
          || this.showProntuarioFormulariosSection
          || this.showProntuarioSettings;
      },
      showCadastrosUsers() {
        return this.hasPermission('List User');
      },
      showCadastrosProfessionals() {
        return this.hasPermission('List Professional');
      },
      showCadastrosPlace() {
        return this.hasPermission('List Place');
      },
      showCadastrosPaymentMethods() {
        return this.hasPermission('List PaymentMethod');
      },
      showCadastrosVisitValues() {
        return this.hasPermission('List Place Visit Value');
      },
      showCadastrosExams() {
        return this.hasPermission('List Place Exams') && this.hasPlatformFeature('exames');
      },
      showCadastrosSupplierTransferValues() {
        return this.hasPermission('List Place Supplier Transfer Value');
      },
      showCadastrosTransferTables() {
        return this.hasPermission('List Transfer Table');
      },
      showCadastrosSpecialties() {
        return this.hasPermission('List Place Specialty');
      },
      showCadastrosAccessTypes() {
        return this.hasPermission('List Place Access Type');
      },
      showCadastrosInsurances() {
        return this.hasPermission('List Place Insurance');
      },
      showCadastrosHolidays() {
        return this.hasPermission('List Place Holiday') && this.hasPlatformFeature('agenda');
      },
      showCadastrosServiceQueues() {
        return this.hasPermission('List Service Queue') && this.hasPlatformFeature('filas');
      },
      showCadastrosTerminals() {
        return this.hasPermission('List Terminal') && this.hasPlatformFeature('filas');
      },
      showCadastrosSection() {
        return this.showCadastrosUsers
          || this.showCadastrosProfessionals
          || this.showCadastrosPlace
          || this.showCadastrosPaymentMethods
          || this.showCadastrosVisitValues
          || this.showCadastrosExams
          || this.showCadastrosSupplierTransferValues
          || this.showCadastrosTransferTables
          || this.showCadastrosSpecialties
          || this.showCadastrosAccessTypes
          || this.showCadastrosInsurances
          || this.showCadastrosHolidays
          || this.showCadastrosServiceQueues
          || this.showCadastrosTerminals;
      },
      showCadastrosMenu() {
        return this.hasPlatformFeature('cadastros') && this.showCadastrosSection;
      },
    },
    watch: {
        '$store.state.auth.permissions': {
            handler() {
                this.initKtMenu();
            },
            deep: true,
        },
        '$store.state.auth.platformModuleSlugs': {
            handler() {
                this.initKtMenu();
            },
            deep: true,
        },
        '$store.state.auth.platformFeatureSlugs': {
            handler() {
                this.initKtMenu();
            },
            deep: true,
        },
        '$store.state.auth.platformSubscription': {
            handler() {
                this.initKtMenu();
            },
            deep: true,
        },
    },
    mounted() {
        this.debouncedInitKtMenu();
    },
    methods: {
        date: moment,
        initKtMenu() {
            this.debouncedInitKtMenu();
        },
        hasPermission(permission) {
            return Permission.has(permission);
        },
        hasPlatformFeature(slug) {
            return checkPlatformFeature(slug);
        },
        hasPlanFeature(slug) {
            return checkPlanFeature(slug);
        },
    },
}
</script>
